import TabPanels from './TabPanels'
export default TabPanels
